(() => {
  class CartReminder extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.count = Number(this.dataset.count) || 0;
      this.mobile = matchMedia('(max-width: 767px)');
      this.label = this.querySelector('[data-cart-reminder-count]');
      this.terms = this.querySelector('#cart-reminder-terms');
      this.sync = this.sync.bind(this);
      this.mobile.addEventListener('change', this.sync, options);
      this.observer = new MutationObserver(this.sync);
      // Cart HTML is replaced after successful additions, quantity changes and removals.
      const cart = document.querySelector('cart-notification');
      if (cart) this.observer.observe(cart, { childList: true, subtree: true });
      this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.resize = new ResizeObserver(() => this.measure());
      this.resize.observe(this);
      document.addEventListener('change', event => {
        if (event.target.matches('.conditions_form_minicart') && this.terms) {
          this.terms.checked = event.target.checked;
        }
      }, options);
      this.terms?.addEventListener('change', () => {
        const checkbox = document.querySelector('.conditions_form_minicart');
        if (checkbox) {
          checkbox.checked = this.terms.checked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, options);
      window.addEventListener('pageshow', event => {
        if (event.persisted) this.refresh();
      }, options);
      this.sync();
    }

    sync() {
      const state = document.querySelector('#minicart[data-cart-item-count]');
      if (state) this.count = Number(state.dataset.cartItemCount) || 0;
      const checkbox = document.querySelector('.conditions_form_minicart');
      if (this.terms && checkbox) this.terms.checked = checkbox.checked;
      const blocked = document.documentElement.matches('.open-drawer, .nav-open, .open-sidebar') ||
        document.body.classList.contains('tingle-enabled') ||
        !!document.querySelector('.minicart__wrapper.open');
      this.hidden = !(this.mobile.matches && this.count > 0 && !blocked);
      const label = String(this.count);
      if (this.label.textContent !== label) this.label.textContent = label;
      // Only toggle when needed: the body is observed for the theme's modal state.
      if (document.body.classList.contains('es-cart-reminder-visible') === this.hidden) {
        document.body.classList.toggle('es-cart-reminder-visible', !this.hidden);
      }
      this.measure();
    }

    measure() {
      document.documentElement.style.setProperty('--es-cart-reminder-height', `${this.hidden ? 0 : this.offsetHeight}px`);
    }

    async refresh() {
      try {
        const response = await fetch(`${this.dataset.cartUrl}.js`, {
          headers: { Accept: 'application/json' }, cache: 'no-store', signal: this.controller.signal,
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (!Number.isFinite(cart.item_count)) return;
        this.count = cart.item_count;
        const state = document.querySelector('#minicart[data-cart-item-count]');
        if (state) state.dataset.cartItemCount = String(this.count);
        this.sync();
      } catch (_) {
        // Keep the last server-rendered state if the return-to-page refresh fails.
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      document.body.classList.remove('es-cart-reminder-visible');
      document.documentElement.style.removeProperty('--es-cart-reminder-height');
    }
  }
  if (!customElements.get('es-cart-reminder')) customElements.define('es-cart-reminder', CartReminder);
})();
